var parts = ['container', 'item', 'icon'];
var baseStyleContainer = {};
var baseStyleItem = {};
var baseStyleIcon = {
  marginEnd: '0.5rem',
  display: 'inline',
  verticalAlign: 'text-bottom'
};
var baseStyle = {
  container: baseStyleContainer,
  item: baseStyleItem,
  icon: baseStyleIcon
};
var List = {
  parts: parts,
  baseStyle: baseStyle
};
export { List as default };